import React from 'react';

import ItemPage from '../components/ItemPage';

const ItemContainer = () => {
  return <ItemPage />;
};

export default ItemContainer;
